import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {VanBanDenService} from '../../../../service/vanbanden/service-vanbanden';
import {VanBanDen} from '../../../../models/vanbanden/vanbanden';
import {EditVanBanDenComponent} from '../soanvanban/edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {CommandUtil} from '../../../../global/commandutil';
import {ChenHoSoVanBanDenComponent} from '../chenhoso/chenhoso.component';
import {XuLyTongHopVanBanDenComponent} from '../xuly/xuly.component';
import {PdfShowComponent} from '../../view/pdf.component';
import {VanBanDenFileService} from '../../../../service/vanbanden/service-vanbandenfile';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';
import {GXLCap2VanBanDenComponent} from '../giaoxuly/giaoxulycap2.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {XuLyDetailVanBanDenComponent} from '../xuly/xulydetail.component';
import {TongHopYKienVanBanDenComponent} from '../xuly/tonghop.component';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {CTVanbanDenComponent} from '../chuyentrinh/chuyentrinh.component';
import {DMNguonService} from '../../../../service/danhmuc/service-dmnguon';
import {DMNguon} from '../../../../models/danhmuc/dmnguon';
import {LogViewItemEgovComponent} from '../../log/logviewitem.component';
@Component({
  templateUrl: './vanbanchuaxuly.component.html',

})
export class VanBanDenChuaXuLyComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  @ViewChild(XuLyDetailVanBanDenComponent)
  public xuLyVanBanDenDetail: XuLyDetailVanBanDenComponent;
  private moduleName:  string = 'egov.info.vanbanden.chuaxuly';
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number =  environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public dataList: VanBanDen[];
  public submitValidate = false;
  public totalDaPhoCap: number =0;
  public totalChuaPhoCap: number =0;
  public totalItemsReal: number= 0;
  public srTuKhoa: string = '';
  public srStatus: string ='';
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public status: number[] = [
    environment.chuaxuly
  ];
  private phoCap: number = -1;
  private nguoiXuLy: number = Sessioncommand.staffId;
  private nguoiChuTri: number = -1;
  private maNoiGui: number =-1;
  private xem: number = 0;
  private checked: boolean = false;
  private dataCheck: Object[]=[];
  private srFromDate: Date ;
  private srToDate: Date;
  private strF: string= '';
  private strT: string= '';
  private permissionCGXuLy: boolean = false;
  private showDetails: boolean = false;
  private vanBanDenId: number = 0;
  private dateCurrent: Date = new Date();
  private nextId: number = 0;
  private permissionView: boolean = false;
  private permissionPhoCap: boolean = false;
  private permissionHuyPhoCap: boolean = false;
  private permissionChenHoSo: boolean = false;
  private permissionDownloadFile: boolean = false;
  private permissionYKienTongHop: boolean = false;
  private permissionChuyenTrinh: boolean = false;
  private permissionGiaoCapDuoi: boolean = false;
  private permissionXuLy: boolean = false;
  private dataLoaiVanBan: LoaiVanBan[] = [];
  private srLoaiVanBan: number =-1;
  private srLinhVucVanBan: number =-1;
  private dataDMNguon: DMNguon[] = [];
  private searchTuongDoi: number = environment.SEARCH_TUONGDOI;
  private searchChinhXac: number = environment.SEARCH_CHINHXAC;
  private srNguonVanBan : string = environment.SEARCH_ALL;
  private srSearchType: number = environment.SEARCH_TUONGDOI;
  constructor(
    private vanBanDenService: VanBanDenService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private bsModalService: BsModalService,
    private vanBanDenFileService: VanBanDenFileService,
    private commandUtil: CommandUtil,
    private formatService: FormatService,
    private datePipe: DatePipe,
    private navItemService: NavItemService,
    private loaiVanBanService: LoaiVanBanService,
    private rolePermissionService: RolePermissionService,
    private dmNguonService: DMNguonService

  ) {
  }
  ngAfterViewInit() {

  }
  public xuLy(id: number) {
      const modalEdit = this.bsModalService.show(XuLyTongHopVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<XuLyTongHopVanBanDenComponent>modalEdit.content).edit(
        id, true
      );
      (<XuLyTongHopVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        if (result == true) {
          let vanBanDenNext: VanBanDen = new VanBanDen();
          this.vanBanDenService.findVanBanXLNext(
            this.srStatus,
            this.phoCap,
            this.nguoiXuLy,
            this.nguoiChuTri,
            this.maNoiGui, this.xem
          ).subscribe(dataItem => {
              vanBanDenNext = dataItem;
              if (vanBanDenNext != null && vanBanDenNext.id != 0)
                this.showConfirmationNext(vanBanDenNext.id);
            }
          );
          this.search();
        }
      });
  }
  public yKienTongHop(id: number) {
    const modalEdit = this.bsModalService.show(TongHopYKienVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienVanBanDenComponent>modalEdit.content).edit(
      id
    );
    (<TongHopYKienVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public checkedItem(event)
  {
    if(event.target.checked== true )
      this.dataCheck.push(event.target.value);
    else
      this.commandUtil.removeItem(event.target.value, this.dataCheck);
    if(this.dataCheck.length==0)
      this.checked=false;
  }
  public checkAll(event)
  {
    this.dataCheck=[];
    this.checked= event.target.checked;
    if(event.target.checked == true)
    {
      for(let i=0;i< this.dataList.length;i++)
        this.dataCheck.push(this.dataList[i].id);
    }
  }
  public summitActive(phoCap: number)
  {

    if(this.dataCheck.length === 0)
    {
      this.toastr.error((phoCap === 1 ? language.message_warning_phocap : language.message_warning_huyphocap), language.message);
    }else
    {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        (phoCap === 1 ? language.questionphocap : language.questionhuyphocap),
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.vanBanDenService.changePhoCap(this.dataCheck.join(), phoCap
          ).subscribe(
            {    next: (data) => {
                this.toastr.success((phoCap === 1 ? language.messagephocap : language.messagehuyphocap), language.message);
                this.search();
                Sessioncommand.vanBanDenStatus = 0;
              },
              error: error => {
                this.toastr.error(language.error, language.message);
              }
            });
        }
      });
    }

  }
  public nextPage()
  {

    if( this.nextId + 1 >= this.dataList.length)
    {
      if(this.currentPage < this.numPages) {
        this.currentPage = this.currentPage + 1;
        this.vanBanDenService.findAllByXLVBTypePaging(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
          this.srLoaiVanBan, this.srLinhVucVanBan,
          this.srStatus,
          this.phoCap,
          this.nguoiXuLy,
          this.nguoiChuTri,
          this.maNoiGui, this.xem, this.strF, this.strT,
          this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.vanBanDenId = this.dataList[0].id;
            this.nextId = 0;
            this.xuLyVanBanDenDetail.edit(this.vanBanDenId);
          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId + 1;
      this.vanBanDenId = this.dataList [ this.nextId === this.dataList.length ? this.dataList.length -1 : this.nextId ].id;
      this.xuLyVanBanDenDetail.edit( this.vanBanDenId);
    }

  }
  public lichSuTruyCap(id: number) {
    const modalEdit = this.bsModalService.show(LogViewItemEgovComponent, {class: 'modal-lg', keyboard: false, backdrop: 'static'});
    (<LogViewItemEgovComponent>modalEdit.content).show(
      id, environment.VANBANDEN
    );
    (<LogViewItemEgovComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public backPage()
  {
    if( this.nextId - 1  < 0)
    {
      if(this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.vanBanDenService.findAllByXLVBTypePaging(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
          this.srLoaiVanBan, this.srLinhVucVanBan,
          this.srStatus,
          this.phoCap,
          this.nguoiXuLy,
          this.nguoiChuTri,
          this.maNoiGui, this.xem, this.strF, this.strT,
          this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.nextId = this.dataList.length - 1;
            this.vanBanDenId = this.dataList[this.nextId].id;
            this.xuLyVanBanDenDetail.edit(this.vanBanDenId);

          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId  - 1;
      this.vanBanDenId = this.dataList [ this.nextId === -1 ? 0 : this.nextId].id;
      this.xuLyVanBanDenDetail.edit( this.vanBanDenId);
    }

  }

  public changePhoCap(id: number, phoCap: number)
  {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      (phoCap === 1 ? language.questionphocap : language.questionhuyphocap),
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.vanBanDenService.changePhoCap(id.toString(), phoCap
        ).subscribe(
          {    next: (data) => {
              this.toastr.success((phoCap == 1 ? language.messagephocap : language.messagehuyphocap), language.message);
              this.search();
              Sessioncommand.vanBanDenStatus = 0;
            },
            error: error => {
              this.toastr.error(language.error, language.message);
            }
          });
      }
    });
  }

  public giaoXuLy(id: number) {
      const modalEdit = this.bsModalService.show(GXLCap2VanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<GXLCap2VanBanDenComponent>modalEdit.content).edit(
        id
      );
      (<GXLCap2VanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        this.search();
        this.loadTotal();
      });

  }
  public chenHoSo(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ChenHoSoVanBanDenComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  ngOnInit(): void {
    this.formatService.getCurrentDateVN().subscribe(x => {
      this.dateCurrent = this.commandUtil.getDate(x);
    });
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view) !== -1;
      if (this.permissionView)
      {
        this.srStatus = this.status.join();
        this.search();
        this.loadTotal();
      }else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionPhoCap = x.findIndex(y => y.action === environment.actionphocap) !== -1;
      this.permissionHuyPhoCap = x.findIndex(y => y.action === environment.actionbophocap) !== -1;
      this.permissionChenHoSo = x.findIndex(y => y.action === environment.chenhoso) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download) !== -1;
      this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop) !== -1;
      this.permissionGiaoCapDuoi = x.findIndex(y => y.action === environment.giaocapduoi) !== -1;
      this.permissionChuyenTrinh = x.findIndex(y => y.action === environment.chuyentrinh) !== -1;
      this.permissionXuLy = x.findIndex(y => y.action === environment.xuly) !== -1;
    });
       this.loaiVanBanService.getAll().subscribe(data => this.dataLoaiVanBan = data);
    this.dmNguonService.getAll().subscribe( data  => this.dataDMNguon = data);
  }
  public chuyenTrinh(id: number) {
    const modalEdit = this.bsModalService.show(CTVanbanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<CTVanbanDenComponent>modalEdit.content).edit(
      id
    );
    (<CTVanbanDenComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public showConfirmationNext(id: number): void {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.message_question_next,
        language.xuly_next,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.xuLy(id);
        }
      });
  }

  public showConfirmationModal(id: number): void {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });
  }
  get f() { return this.frmGroup.controls; }
  edit(id: number) {
      const modalEdit = this.bsModalService.show(EditVanBanDenComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditVanBanDenComponent>modalEdit.content).edit(
        id
      );
      (<EditVanBanDenComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.search();
        }
      });
  }
  public detailXuLy(id: number) {
      if(this.permissionXuLy) {
        this.vanBanDenId = id;
        this.nextId = this.dataList.findIndex(x => x.id === id);
        this.showDetails = true;
      }
  }
  showFile(id: number) {
    this.vanBanDenFileService.findAllByVanBanId(id).subscribe( x=>{
      if(x.length > 0)
      {
        const modalEdit = this.bsModalService.show(PdfShowComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
        (<PdfShowComponent>modalEdit.content).show(
          this.commandUtil.getUrlDownload(x[0].folder, x[0].fileKey, x[0].width, x[0].name)

        );
        (<PdfShowComponent>modalEdit.content).onClose.subscribe(result => {
          if (result === true) {
            this.search();
          }
        });
      }
    });
  }
  public loadTotal()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.getCountByXLVBTypeKeyword(this.srTuKhoa, this.srSearchType, this.srNguonVanBan, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.daPhoCap, this.nguoiXuLy, this.nguoiChuTri, this.maNoiGui, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalDaPhoCap = recordCount);
    this.vanBanDenService.getCountByXLVBTypeKeyword(this.srTuKhoa, this.srSearchType, this.srNguonVanBan, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.chuaPhoCap, this.nguoiXuLy, this.nguoiChuTri, this.maNoiGui, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalChuaPhoCap = recordCount);
    this.vanBanDenService.getCountByXLVBTypeKeyword(this.srTuKhoa, this.srSearchType, this.srNguonVanBan, this.srLoaiVanBan, this.srLinhVucVanBan, this.srStatus, CommandUtil.defaultValue, this.nguoiXuLy, this.nguoiChuTri, this.maNoiGui, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalItemsReal = recordCount);
  }
  search()
  {

    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.vanBanDenService.findAllByXLVBTypePaging(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiXuLy,
      this.nguoiChuTri,
      this.maNoiGui, this.xem,
      this.strF, this.strT,
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.vanBanDenService.getCountByXLVBTypeKeyword(this.srTuKhoa, this.srSearchType, this.srNguonVanBan,
      this.srLoaiVanBan, this.srLinhVucVanBan,
      this.srStatus,
      this.phoCap,
      this.nguoiXuLy,
      this.nguoiChuTri,
      this.maNoiGui, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
      this.vanBanDenService.delete(id).subscribe({
        next: () => {
          this.toastr.success(language.delete_success_record, language.message);
          this.search();
          Sessioncommand.vanBanDenStatus = 0;

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

